import { useEffect, useState } from "react";

import { Page } from "@/ui/Layout";
import { Container } from "@/ui/Layout/Page";
import { TabsComponent } from "@/ui/TabsComponent";
// import { ShieldIcon } from "@/ui/Icons";
import {
  APISettingsModal,
  CustomWebHookModal,
  DeleteIntegrationModal,
} from "./Popups";
import { getUserIntegrations } from "../../api/integrations";
import { getSessionToken } from "@/api/auth";
import { ConnectedAccounts } from "./ConnectedAccounts";
import { CustomWebHooks } from "./CustomWebHooks";
import { useNavigate } from "react-router-dom";
import { useSession } from "@clerk/clerk-react";

import { Passthrough } from "@/ui/Layout/Passthrough";

/** `embedded`: shown as a Settings tab, so no page frame and no tab strip of its own. */
export const Integrations = ({ embedded = false }: { embedded?: boolean }) => {
  const Shell: any = embedded ? Passthrough : Page;
  const Box: any = embedded ? Passthrough : Container;
  const [isIntegrationsPopupShowing, setIntegrationsPopupIsShowing] =
    useState(false);
  const [isCustomWebHookModalShowing, setIsCustomWebHookModalShowing] =
    useState(false);
  const [isDeleteIntegrationModalShowing, setIsDeleteIntegrationModalShowing] =
    useState(false);

  const [activeIntegrations, setActiveIntegrations] = useState([]);
  const [activeIntegrationId, setActiveIntegrationId] = useState(null);
  const [activeProviderId, setActiveProviderId] = useState(null);

  const navigation = useNavigate();
  const { isSignedIn } = useSession();
  
  const loadIntegrations = async () => {
    const token = getSessionToken();
    const response = await getUserIntegrations({ token });
    setActiveIntegrations(response);
  };

  useEffect(() => {
    loadIntegrations();
  }, []);

  return (
    <Shell {...(embedded ? {} : { topBar: { page: [{ label: "Integrations" }] } })}>
      {isIntegrationsPopupShowing && (
        <APISettingsModal
          activeProviderId={activeProviderId}
          activeIntegrationId={activeIntegrationId}
          setIsOpen={setIntegrationsPopupIsShowing}
        />
      )}

      {isCustomWebHookModalShowing && (
        <CustomWebHookModal
          activeIntegrationId={activeIntegrationId}
          setIsOpen={setIsCustomWebHookModalShowing}
        />
      )}

      {isDeleteIntegrationModalShowing && (
        <DeleteIntegrationModal
          activeIntegrationId={activeIntegrationId}
          setIsOpen={setIsDeleteIntegrationModalShowing}
        />
      )}

      <Box>
        {!embedded && <TabsComponent
          tabs={[
            ...(!isSignedIn ? [{ label: "Profile", value: "profile" }] : []),
            { label: "Domain Names", value: "domains" },
            { label: "Integrations", value: "integrations" },
          ]}
          activeTab={"integrations"}
          setActiveTab={(val) => {
            // window.location.href = `/${val}`;
            navigation(`/${val}`);
          }}
          actionSection={false}
        />}

        <div className="grid grid-cols-1 gap-5">
          <ConnectedAccounts
            setIntegrationsPopupIsShowing={setIntegrationsPopupIsShowing}
            showIntegrationsPopup={(id, providerId) => {
              console.log({ id, providerId });
              if (providerId) setActiveProviderId(providerId);
              setActiveIntegrationId(id);
              setIntegrationsPopupIsShowing(true);
            }}
            activeIntegrations={activeIntegrations}
            setActiveIntegrations={setActiveIntegrations}
            activeIntegrationId={activeIntegrationId}
            setActiveIntegrationId={setActiveIntegrationId}
            setActiveProviderId={setActiveProviderId}
            setIsDeleteIntegrationModalShowing={
              setIsDeleteIntegrationModalShowing
            }
          />

          <CustomWebHooks
            setIsCustomWebHookModalShowing={setIsCustomWebHookModalShowing}
            activeIntegrations={activeIntegrations}
            setActiveIntegrations={setActiveIntegrations}
            activeIntegrationId={activeIntegrationId}
            setActiveIntegrationId={setActiveIntegrationId}
            setIsDeleteIntegrationModalShowing={
              setIsDeleteIntegrationModalShowing
            }
          />
        </div>
      </Box>
    </Shell>
  );
};
